(() => {
 'use strict';
 const $ = s => document.querySelector(s);
  function updateDublinClock() {
    const now = new Date();
    const clock = $('#dublin-clock');
    clock.dateTime = now.toISOString();
    clock.textContent = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Dublin',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).format(now);
  }
  updateDublinClock();
  setInterval(() => {if (!document.hidden) updateDublinClock();},1000);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) updateDublinClock();});
  const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
  let layoutFrame = null;
  function refreshLayout() {
    const opening = $('.hero');
    if (opening) opening.classList.toggle('is-tall',opening.offsetHeight > innerHeight + 2);
    for (const element of [$('.wordmark'), $('.site-header nav')]) {
      const r = element.getBoundingClientRect();
      const x = Math.min(innerWidth - 1, Math.max(0,r.left + r.width / 2));
      const y = Math.max(0,r.top + r.height / 2);
      const beneath = document.elementsFromPoint(x,y).find(el => !el.closest('#site-header') && !el.closest('#cursor') && el.closest('main,footer'));
      element.classList.toggle('on-dark',Boolean(beneath && beneath.closest('[data-tone="dark"]')));
    }
    const info = $('.product-info');
    if (info) {
      info.style.setProperty('--panel-height', info.offsetHeight + 'px');
      info.classList.toggle('needs-scroll',innerWidth > 760 && info.offsetHeight > innerHeight - 150);
    }
    layoutFrame = null;
  }
  function scheduleLayout() {
    if (layoutFrame === null) layoutFrame = requestAnimationFrame(refreshLayout);
  }
  addEventListener('scroll',scheduleLayout,{passive:true});
  document.addEventListener('745:motion',scheduleLayout);
  addEventListener('resize',scheduleLayout);
  motionQuery.addEventListener('change',scheduleLayout);
  if ($('.product-info')) new ResizeObserver(scheduleLayout).observe($('.product-info'));
  if ($('.hero')) new ResizeObserver(scheduleLayout).observe($('.hero'));
  refreshLayout();
  document.fonts.ready.then(scheduleLayout);
  if (location.hash) {
    requestAnimationFrame(() => {
      const target = document.getElementById(location.hash.slice(1));
      if (target) target.scrollIntoView({behavior:'instant',block:'start'});
    });
  }
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const cursor = $('#cursor');
    let tx=0,ty=0,cx=0,cy=0,active=false,frame=null;
    function updateHover() {
      const element = document.elementFromPoint(tx,ty);
      cursor.classList.toggle('is-hover',Boolean(element && element.closest('a,button,summary')));
    }
    function animateCursor() {
      const amount = motionQuery.matches ? 1 : .55;
      cx += (tx - cx) * amount;
      cy += (ty - cy) * amount;
      const ratio = devicePixelRatio || 1;
      cursor.style.transform = 'translate(' + Math.round(cx * ratio) / ratio + 'px,' + Math.round(cy * ratio) / ratio + 'px)';
      if (active && (Math.abs(tx-cx) + Math.abs(ty-cy) > .03)) frame = requestAnimationFrame(animateCursor);
      else frame = null;
    }
    document.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') return;
      tx=e.clientX;ty=e.clientY;
      if (!active) {active=true;cx=tx;cy=ty;}
      document.body.classList.add('cursor-ready');
      updateHover();
      if (frame === null) frame=requestAnimationFrame(animateCursor);
    },{passive:true});
    document.addEventListener('keydown',e=>{if(e.key==='Tab') document.body.classList.remove('cursor-ready');});
    function stopCursor() {
      active=false;
      if(frame !== null) cancelAnimationFrame(frame);
      frame=null;
      document.body.classList.remove('cursor-ready');
    }
    document.documentElement.addEventListener('pointerleave',stopCursor);
    addEventListener('blur',stopCursor);
    addEventListener('scroll',()=>{if(active)updateHover();},{passive:true});
  }

})();
